var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaErfolgsgeschichteBwOnlineShopRaketeStartItem10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 581,
    height: 182,
    viewBox: "0 0 581 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M539.304 45.5706C485.011 16.484 381.36 0.758789 290.152 0.758789C198.841 0.758789 95.0879 16.484 40.7948 45.5706H41.1033C-54.9378 97.063 13.0313 181.65 290.461 181.65C567.684 181.65 635.448 97.063 539.304 45.5706ZM42.8514 45.5706H55.2935C104.034 17.8202 202.337 2.50605 290.049 2.50605V0.96436C380.846 0.96436 483.88 16.5868 537.453 45.5706H524.188C607.067 92.8491 535.705 166.028 290.358 166.028V179.698C17.0416 179.595 -51.4417 96.5491 42.8514 45.5706Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.3953 45.5706C95.6884 16.484 199.339 0.758789 290.547 0.758789C381.858 0.758789 485.611 16.484 539.904 45.5706H539.596C635.637 97.063 567.668 181.65 290.239 181.65C13.0149 181.65 -54.7487 97.063 41.3953 45.5706ZM537.848 45.5706H525.406C476.665 17.8202 378.362 2.50605 290.65 2.50605V0.96436C199.853 0.96436 96.8195 16.5868 43.2462 45.5706H56.511C-26.3682 92.8491 44.9943 166.028 290.341 166.028V179.698C563.658 179.595 632.141 96.5491 537.848 45.5706Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 580.517,
    y1: 181.65,
    x2: 477.761,
    y2: -148.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.18267,
    y1: 181.65,
    x2: 102.939,
    y2: -148.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaErfolgsgeschichteBwOnlineShopRaketeStartItem10);
export default __webpack_public_path__ + "static/media/alkima-erfolgsgeschichte-bw-online-shop-rakete-start-item-10.b9e5f900da5ff163d5ff850bf5b30947.svg";
export { ForwardRef as ReactComponent };